import { useEffect, useState } from 'react';

/**
 * usePrefersReducedMotion — tracks the `prefers-reduced-motion: reduce` media
 * query. Returns `true` when the user has requested reduced motion, so motion
 * primitives (rotating/typewriter hero words) can render a static fallback.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mq.matches);
    const handler = (e: MediaQueryListEvent): void => setReduced(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return reduced;
}

export default usePrefersReducedMotion;
